export const connectionTypes = {
  SET_IS_RECONNECTING: "SET_IS_RECONNECTING",
  SET_IS_CONNECTED: "SET_IS_CONNECTED",
};
